import { UIButton, UIColor, UITextView } from "uicore-ts"
import { RHButtons, RHFont, RHShadow } from "../Custom components/RH/Utils_slop/RHDesignTokens"
import { RHLoginViewTokens } from "../Custom components/RH/Utils_slop/RHViewTokens"

export class GoogleLoginButton extends UIButton {
    
    private static readonly _logoSource = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4Ij48cGF0aCBmaWxsPSIjRUE0MzM1IiBkPSJNMjQgOS41YzMuNTQgMCA2LjcxIDEuMjIgOS4yMSAzLjZsNi44NS02Ljg1QzM1LjkgMi4zOCAzMC40NyAwIDI0IDAgMTQuNjIgMCA2LjUxIDUuMzggMi41NiAxMy4yMmw3Ljk4IDYuMTlDMTIuNDMgMTMuMDggMTcuNzQgOS41IDI0IDkuNXoiLz48cGF0aCBmaWxsPSIjNDI4NUY0IiBkPSJNNDYuOTggMjQuNTVjMC0xLjU3LS4xNS0zLjA5LS4zOC00LjU1SDI0djkuMDJoMTIuOTRjLS41OCAyLjk2LTIuMjYgNS40OC00Ljc4IDcuMThsNy43MyA2YzQuNTEtNC4xOCA3LjA5LTEwLjM2IDcuMDktMTcuNjV6Ii8+PHBhdGggZmlsbD0iI0ZCQkMwNSIgZD0iTTEwLjUzIDI4LjU5Yy0uNDgtMS40NS0uNzYtMi45OS0uNzYtNC41OXMuMjctMy4xNC43Ni00LjU5bC03Ljk4LTYuMTlDLjkyIDE2LjQ2IDAgMjAuMTIgMCAyNGMwIDMuODguOTIgNy41NCAyLjU2IDEwLjc4bDcuOTctNi4xOXoiLz48cGF0aCBmaWxsPSIjMzRBODUzIiBkPSJNMjQgNDhjNi40OCAwIDExLjkzLTIuMTMgMTUuODktNS44MWwtNy43My02Yy0yLjE4IDEuNDgtNC45MyAyLjMxLTguMTYgMi4zMS02LjI2IDAtMTEuNTctMy41OS0xMy40Ni04LjkxbC03Ljk4IDYuMTlDNi41MSA0Mi42MiAxNC42MiA0OCAyNCA0OHoiLz48L3N2Zz4="
    
    // Google spec: #FFFFFF fill, #747775 1px stroke, #1F1F1F text, Roboto Medium 14px
    private static readonly _fillColor = new UIColor("#ffffff")
    private static readonly _fillColorHovered = new UIColor("#f2f2f2")
    private static readonly _fillColorHighlighted = new UIColor("#e8e8e8")
    private static readonly _textColor = new UIColor("#1f1f1f")
    private static readonly _strokeColor = "#747775"
    
    constructor(elementID?: string) {
        
        super(elementID, "button")
        
        // Must explicitly unhide — UIButton constructor sets imageView.hidden = YES
        this.imageView.imageSource = GoogleLoginButton._logoSource
        this.imageView.hidden = false
        
        this.titleLabel.configureWithObject({
            text: "Logi sisse Google'iga",
            textAlignment: UITextView.textAlignment.left,
            style: {
                // fontFamily: "'Roboto', sans-serif",
                fontFamily: RHFont.familyBase,
                fontWeight: "500",
                // fontSize: "14px",
                fontSize: RHLoginViewTokens.oauthButtonLabelFontSize,
                color: GoogleLoginButton._textColor.stringValue,
                whiteSpace: "nowrap"
            }
        })
        
        this.configureWithObject({
            // @ts-ignore
            style: {
                boxSizing: "border-box",
                backgroundColor: GoogleLoginButton._fillColor.stringValue,
                border: `1px solid ${GoogleLoginButton._strokeColor}`,
                // borderRadius: "4px",
                borderRadius: RHButtons.borderRadius,
                cursor: "pointer",
                overflow: "hidden",
                transition: "background-color 0.1s ease, box-shadow 0.1s ease"
            }
        })
        
        this.colors = {
            titleLabel: {
                normal: GoogleLoginButton._textColor,
                highlighted: GoogleLoginButton._textColor,
                selected: GoogleLoginButton._textColor,
                hovered: GoogleLoginButton._textColor,
                focused: GoogleLoginButton._textColor
            },
            background: {
                normal: GoogleLoginButton._fillColor,
                hovered: GoogleLoginButton._fillColorHovered,
                highlighted: GoogleLoginButton._fillColorHighlighted,
                focused: GoogleLoginButton._fillColorHovered,
                selected: GoogleLoginButton._fillColor
            }
        }
        
        this.updateContentForNormalState()
        
    }
    
    override updateContentForNormalState() {
        super.updateContentForNormalState()
        this.style.backgroundColor = GoogleLoginButton._fillColor.stringValue
        // this.style.boxShadow = "0 1px 2px rgba(0,0,0,0.12)"
        this.style.boxShadow = RHShadow.subtle
    }
    
    override updateContentForHoveredState() {
        super.updateContentForHoveredState()
        this.style.backgroundColor = GoogleLoginButton._fillColorHovered.stringValue
        // this.style.boxShadow = "0 1px 3px rgba(0,0,0,0.18)"
        this.style.boxShadow = RHShadow.medium
    }
    
    override updateContentForFocusedState() {
        super.updateContentForFocusedState()
        this.style.backgroundColor = GoogleLoginButton._fillColorHovered.stringValue
        this.style.boxShadow = "0 0 0 3px rgba(66,133,244,0.3)"
    }
    
    override updateContentForHighlightedState() {
        super.updateContentForHighlightedState()
        this.style.backgroundColor = GoogleLoginButton._fillColorHighlighted.stringValue
        // this.style.boxShadow = "0 1px 2px rgba(0,0,0,0.12)"
        this.style.boxShadow = RHShadow.subtle
    }
    
    
    override layoutSubviews() {

        // super.layoutSubviews()

        const bounds = this.bounds
        const logoSize = 18
        const logoToTextGap = 10

        // Center the logo + label as a single group within the button (instead of pinning it
        // to the left edge), so the wide button reads as intentional and balanced.
        const titleWidth = this.titleLabel.intrinsicContentWidth(bounds.height)
        const groupWidth = logoSize + logoToTextGap + titleWidth
        const groupLeft = [(bounds.width - groupWidth) * 0.5, 0].max()

        this.imageView.style.left = groupLeft + "px"
        this.imageView.style.width = logoSize + "px"
        this.imageView.style.height = logoSize + "px"
        this.imageView.style.top = (bounds.height - logoSize) * 0.5 + "px"

        this.titleLabel.style.left = (groupLeft + logoSize + logoToTextGap) + "px"
        this.titleLabel.style.right = "auto"
        this.titleLabel.style.width = (titleWidth + RHLoginViewTokens.oauthButtonLabelSafetyBuffer) + "px"
        this.titleLabel.style.top = "50%"
        this.titleLabel.style.transform = "translateY(-50%)"

    }
    
}
